<script>
import draggable from "vuedraggable";
import QuotesModal from "@/components/Quotes/QuotesModal.vue";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import VDialogConfirm from "@/components/commonComponents/VDialogConfirm.vue";
import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";

export default {
    name: "ProjectsDigestsItemQuotes",
    components: {
        VIconTooltip,
        VDialogConfirm,
        QuotesModal,
        draggable,
    },
    mixins: [
        ComponentsKeys,
    ],
    props: {
        value: {
            type: Array,
        },
        disabled: {
            type: Boolean,
        },
        idProject: {
            type: String,
        },
        wasModified: {
            type: Boolean,
        },
        isCanSubmit: {
            type: Boolean,
        },
    },
    data() {
        return {
            componentsKeys: {
                quotesModal: this.getRandomKey('quotesModal')
            },
        };
    },
    computed: {
        items: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            },
        },
    },
    methods: {
        onClickRemove(item) {
            this.items = this.items.filter(v => v !== item);
        },
        onDblClick(item) {
            Promise.resolve()
                .then(() => {
                    if (this.wasModified) {
                        return this.$refs.quotesModalConfirm.show();
                    }
                    return 'open';
                })
                .then(resultConfirm => {
                    if (resultConfirm) {
                        this.$refs.quotesModal.show(item.id)
                            .then((result) => {
                                if (result !== false || resultConfirm === 'save') {
                                    this.$emit('reload');
                                }
                            })
                            .finally(() => {
                                this.updateComponentKey('quotesModal');
                            });
                    }
                })
                .catch(this.notifyError);
        },
        onClickConfirmSave() {
            return this.$listeners.save.fns()
                .then(() => 'save');
        },
        onClickConfirmOpen() {
            return 'open';
        },
        onClickAdd() {
            this.$emit("add");
        }
    },
}
</script>

<template>
    <v-list two-line>
        <draggable
            v-model="items"
            :disabled="disabled"
            handle=".draggable"
        >
            <template v-for="(item, i) in items">
                <v-list-item
                    :key="item.id"
                    @dblclick="onDblClick(item)"
                    class="clickable"
                >
                    <v-list-item-avatar color="grey" :class="{draggable: !disabled}">
                        <span style="user-select:none;">{{ i + 1 }}</span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.speaker_name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ item.speaker_position }}
                        </v-list-item-subtitle>
                        <v-list-item-content>
                            {{ item.text }}
                        </v-list-item-content>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon-tooltip
                            :disabled="disabled"
                            @click="onClickRemove(item)"
                            icon="mdi-link-off"
                        >
                            Исключить цитату из аналитического материала
                        </v-icon-tooltip>
                    </v-list-item-action>
                </v-list-item>
            </template>

            <v-list-item
                slot="footer"
                inactive
                v-if="!disabled"
            >
                <v-list-item-avatar color="grey">
                    <v-btn
                        icon
                        :dark="false"
                        @click="onClickAdd"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-list-item-avatar>

                <v-list-item-action class="ml-0">
                    <v-btn
                        @click="onClickAdd"
                        color="primary"
                    >
                        <v-icon left>mdi-link-plus</v-icon> Привязать цитату
                    </v-btn>
                </v-list-item-action>

            </v-list-item>
        </draggable>

        <quotes-modal
            ref="quotesModal"
            :key="componentsKeys.quotesModal"
            :id-project="idProject"
        ></quotes-modal>

        <v-dialog-confirm
            ref="quotesModalConfirm"
            @save="onClickConfirmSave"
            @open="onClickConfirmOpen"
        >
            При редактировании цитаты, дайджест будет перезагружен и несохраненные данные потеряны. Продолжить?
            <template v-slot:actions="{handlers, isDisabled}">
                <v-spacer></v-spacer>
                <v-btn @click="handlers.save" :disabled="!isCanSubmit || isDisabled">
                    Сохранить и открыть
                </v-btn>
                <v-btn @click="handlers.open" :disabled="isDisabled">
                    Открыть без сохранения
                </v-btn>
                <v-btn @click="handlers.close" :disabled="isDisabled">
                    Отмена
                </v-btn>
            </template>
        </v-dialog-confirm>
    </v-list>
</template>

<style scoped lang="css">
>>> .draggable {
    cursor: move;
}

>>> .clickable {
    cursor: pointer;
}
</style>
